/**
 *
 * @module receiptCredentials
 *
 */

import Check from 'check-types';
import Util from './../util/entry';
import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    nonEmptyString,
    object
} = Check.assert;

/**
 *
 * @class ReceiptCredentials
 * @desc Represents the data used to authenticate a purchase activation.
 *
 */
export default class ReceiptCredentials {

    /**
     *
     * @param {String} store - the store associated with this receipt
     * @param {Object} receipt - contains information about the purchase you are trying to validate
     *
     */
    constructor(store, receipt) {

        const errorMessage = {
            ctor: 'ReceiptCredentials(store, receipt)',
            get store() {
                return `${this.ctor} store should be a string with length`;
            },
            get receipt() {
                return `${this.ctor} receipt should be an Object`;
            }
        };

        nonEmptyString(store, errorMessage.store, InvalidArgumentException);
        object(receipt, errorMessage.receipt, InvalidArgumentException);

        /**
         *
         * @access public
         * @type String
         * @desc the store associated with this receipt
         *
         */
        this.store = store;

        /**
         *
         * @access public
         * @type Object
         * @desc the receipt used to validate the purchase
         *
         */
        this.receipt = receipt;

    }

    /* #region private: */

    /**
     *
     * @access private
     * @returns {Object} the payload being sent to services to validate the store purchase
     *
     */
    payload() {

        const receipt = this.receipt;
        let payload = {};

        switch (this.store) {

            case 'apple':
                payload = {
                    receiptBundle: Util.getSafe(() => receipt.properties.receiptBundle),
                    email: Util.getSafe(() => receipt.properties.email),
                    identifierForVendor: Util.getSafe(() => receipt.properties.identifierForVendor)
                };
                break;

        }

        return payload;

    }

    /**
     *
     * @access private
     * @returns {String} the name of the store
     *
     */
    getStore() {

        return this.store;

    }

}



// WEBPACK FOOTER //
// ./src/services/purchase/receiptCredentials.js